<div class="mt-24">
  <div class="filter">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Компания</label>
          <app-select-multiple
            [initBy]="filter.companiesSelected"
            [initByKey]="'campaign_id'"
            [items]="data.companiesList"
            [textKey]="'new_name'"
            [defaultText]="'Выберите компанию'"
            (callback)="onChangeCompanies($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Регион</label>
          <app-select-multiple
            [initBy]="filter.regionsSelected"
            [initByKey]="'name'"
            [items]="data.regionsList"
            [textKey]="'name'"
            [defaultText]="'Выберите регион'"
            (callback)="onChangeRegions($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Филиал</label>
          <app-select-multiple
            [initBy]="filter.branchesSelected"
            [initByKey]="'mb_id'"
            [items]="data.branchesList"
            [textKey]="'mb_name'"
            [defaultText]="'Выберите филиал'"
            (callback)="onChangeBranches($event)"
            [isDisabled]="!data.branchesList || !data.branchesList.length"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Город</label>
          <app-select-multiple
            [initBy]="filter.citiesSelected"
            [initByKey]="'ct_id'"
            [items]="data.citiesList"
            [textKey]="'ct_name'"
            [defaultText]="'Выберите город'"
            (callback)="onChangeCities($event)"
            [isDisabled]="!data.citiesList || !data.citiesList.length"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Участок</label>
          <app-select-multiple
            [initBy]="filter.sectorsSelected"
            [initByKey]="'sector_id'"
            [items]="data.sectorsList"
            [textKey]="'sector_number_str'"
            [defaultText]="'Выберите участок'"
            (callback)="onChangeSectors($event)"
            [isDisabled]="!data.sectorsList || !data.sectorsList.length"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Район</label>
          <app-select-multiple
            [initBy]="filter.districtsSelected"
            [initByKey]="'d_id'"
            [items]="data.districtsList"
            [textKey]="'new_name'"
            [defaultText]="'Выберите район'"
            (callback)="onChangeDistricts($event)"
            [isDisabled]="!data.districtsList || !data.districtsList.length"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-field>
          <label>Роль участка</label>
          <app-select class="tbl__role"
                      #roleSelect
                      [textKey]="'name'"
                      (callback)="handleSectorRoleChange($event)"
                      [items]="sectorRoleOptions"
                      [defaultText]="'Выберите роль'">
          </app-select>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min mt-16 pt-4">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <button class="button" type="button" id="appApplyFilterPlot" (click)="onApplyFilter()" [disabled]="!checkDisabledApplyFilterButton()">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link link--dotted-blue-dark" id="appResetFilterPlot"
               (click)="onResetFilter(); roleSelect.onReset();">
              Сбросить
            </a>
          </div>
          <div class="grid__box grid__box--size-min">
            <app-checkbox>
              <input type="checkbox" id="appShowDisabledPlots" [checked]="filter.isVisibleHiddenSectors" (change)="filter.onChangeVisibleHiddenPlots($event)" />
              <checkbox-text>Показать отключенные</checkbox-text>
            </app-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
